export enum TeamTypesEnum {
    ARTISTIC_DIRECTOR = "ARTISTIC_DIRECTOR",
    PROJECT_MANAGER = "PROJECT_MANAGER",
    ASSISTANT = "ASSISTANT"
}